// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_pMt","cls2":"RelatedPapers-cls2_q_C RelatedPapers-cls1_pMt"};